import React from "react";
import { BusinessUnitTableColumns } from "./BusinessUnitTableColumns";
import Vendor from "data/Vendor";
import { BusinessUnit } from "data/BusinessUnit";
import BusinessUnitListTable from "./BusinessUnitListTable";
import LoadingIndicator from "components/UI/LoadingIndicator";
import ConfirmationModal from "components/UI/ConfimationModal";
import { GENERAL_CONSTANTS } from "constants/general";
import { useBusinessUnitActions } from "hooks/useBusinessUnitAction";

interface Props {
    selectedVendor?: Vendor;
    selectedBusinessUnit?: BusinessUnit | null;
    reload: boolean;
    setReload: (reload: boolean) => void;
}

const BusinessUnitsTab = ({ selectedVendor, selectedBusinessUnit, reload, setReload }: Props) => {
    const {
        selectedRows,
        setSelectedRows,
        handleEdit,
        handleDelete,
        handleDeleteMultiple,
        modalConfigs,
        modalState,
        hideModal,
        deleteBusinessUnitReq,
    } = useBusinessUnitActions({reload, setReload});

    if (deleteBusinessUnitReq.isLoading) return <LoadingIndicator />;

    return (
        <>
            {Object.entries(modalConfigs).map(([key, config]) => (
                <ConfirmationModal
                    key={key}
                    show={modalState[key]}
                    onClose={() => hideModal(key)}
                    onConfirm={config.onConfirm}
                    title={config.title}
                    message={config.message}
                    confirmText={GENERAL_CONSTANTS.CONFIRM}
                    cancelText={GENERAL_CONSTANTS.CANCEL}
                />
            ))}
            <BusinessUnitListTable
                unitColumns={BusinessUnitTableColumns}
                selectedVendorId={selectedVendor?.id}
                selectedBusinessUnit={selectedBusinessUnit}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                reload={reload}
                setReload={setReload}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleDeleteMultiple={handleDeleteMultiple}
            />
           
        </>
    );
};

export default BusinessUnitsTab;